import React from 'react';
import {useTable, useTableState} from 'src/design/organisms/useTable';
import {useGetProjectRosterListV2Query} from 'src/redux/queries/project';
import {useProjectRosterColumns} from './hooks/useProjectRosterColumns';

export interface ProjectRosterTabProps {
  projectId: number;
}

// Read-only view of who is on the project and which assignment rule(s) added
// them; membership itself is owned by the Assignment Rules tab.
export const ProjectRosterTab: React.FC<ProjectRosterTabProps> = ({
  projectId,
}) => {
  const columns = useProjectRosterColumns();

  const tableState = useTableState({
    identifier: 'project-roster',
    columns: columns,
    defaultDensity: 'xs',
    defaultPagination: {
      pageIndex: 0,
      pageSize: 20,
    },
    defaultSorting: [{id: 'userName', desc: false}],
    defaultShowColumnFilters: true,
  });

  const {start, length, filters, filterFns, sorting} = tableState;

  const params = {
    projectId,
    request: {
      start: start,
      length: length,
      filters: filters,
      filterFns: filterFns,
      sorting: sorting,
    },
  };
  const {data, isLoading, isError, isFetching, refetch} =
    useGetProjectRosterListV2Query(params, {refetchOnMountOrArgChange: true});

  const rows = data?.data ?? [];
  const totalCount = data?.totalRecords ?? 0;

  const {table} = useTable({
    ...tableState,
    tableOptions: {
      manualSorting: true,
      manualFiltering: true,
      manualPagination: true,
      enableRowActions: false,
      columns: columns,
      data: rows,
    },
    totalCount,
    isError,
    isLoading,
    isFetching,
    onRefresh: refetch,
  });

  return <>{table}</>;
};
